module.exports = __webpack_public_path__ + "static/media/Photorealistic-100.f2cbf536.webp";